const TARGETING_GENDERS_TYPES = [
  {
    key: 0,
    name: "Vše",
  },
  {
    key: 1,
    name: "Muži",
  },
  {
    key: 2,
    name: "Ženy",
  },
]

const TARGETING_GEO_LOCATIONS_TYPES = [
  {
    key: "home,recent",
    name: "Lidé, kteří v této lokalitě žijí, nebo ji nedávno navštívili",
  },
  {
    key: "home",
    name: "Lidé, kteří v této lokalitě žijí",
  },
  {
    key: "recent",
    name: "Lidé, kteří v této lokalitě nedávno byli",
  },
  {
    key: "travel_in",
    name: "Lidé, kteří v této lokalitě cestují",
  },
]

const TARGETING_LOCATIONS_TYPES = [
  {
    key: "city",
    name: "Město",
  },
  {
    key: "country",
    name: "Stát",
  },
  {
    key: "neighborhood",
    name: "Okolí",
  },
]

export {
  TARGETING_GENDERS_TYPES,
  TARGETING_GEO_LOCATIONS_TYPES,
  TARGETING_LOCATIONS_TYPES,
}
